import { render, staticRenderFns } from "./TolRouteAdd.vue?vue&type=template&id=1afa7ec4&scoped=true"
import script from "./TolRouteAdd.vue?vue&type=script&lang=js"
export * from "./TolRouteAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa7ec4",
  null
  
)

export default component.exports